import { Role } from '../enum';

export const hasAccess = (role: Role, requiredRoles: Role[]) =>
  requiredRoles.includes(role) || requiredRoles.length === 0;
